/* Shared, deterministic rules for the MamaWillow review reader. */
(() => {
  // Checked against the original text: Yotpo's automatic language was missing or wrong.
  const correctedLanguages = {888938433:'it',888938068:'de',888938247:'de',774580422:'it',771212110:'it',770658474:'it',766954884:'it'};
  const words = {
    de: new Set('der die das und nicht sehr ich habe sind wird werden wäsche wasche waschmittel spülmaschine spülmaschinenblätter duft sauber blätter zufrieden leider aber ist mit auch für eine ein mein meine beim keine gutes gute gut angenehm teuer reinigt gefällt'.split(' ')),
    it: new Set('il lo la gli le e non molto sono ho questo questa bucato detersivo piatti lavastoviglie profumo pulito fogli prodotto ottimo ottima soddisfatta soddisfatto consiglio anche per una un mio mia piace buon buono benissimo perfetto trovo'.split(' ')),
    en: new Set('the and not very have this that laundry dishwasher sheets smell clean product good pleased would with great they are was has using buy again leaves'.split(' '))
  };
  function text(value) {
    return String(value || '').replace(/<br\s*\/?\s*>/gi,'\n').replace(/<[^>]*>/g,'').replace(/&(?:#39|apos);/g,"'").replace(/&quot;/g,'"').replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&nbsp;/g,' ').trim();
  }
  function language(review) {
    if (correctedLanguages[review.id]) return correctedLanguages[review.id];
    const source = String(review.language || '').toLowerCase().split(/[-_]/)[0];
    const tokens = new Set(text(`${review.title} ${review.content}`).toLowerCase().match(/[\p{L}]+/gu) || []);
    const scores = Object.entries(words).map(([code,list])=>[code,[...tokens].filter(w=>list.has(w)).length]).sort((a,b)=>b[1]-a[1]);
    // Correct only strong textual evidence; never infer language from nationality.
    if (scores[0][1] >= 4 && scores[0][1] >= scores[1][1] + 3) return scores[0][0];
    if (source) return source;
    return scores[0][1] >= 2 && scores[0][1] > scores[1][1] ? scores[0][0] : 'und';
  }
  function normalize(review, products) {
    const linked = products.find(p=>String(p.id)===String(review.product_id)) || (products.length===1 ? products[0] : null);
    return {
      id:String(review.id), score:Number(review.score), title:text(review.title), content:text(review.content),
      date:review.createdAt || review.created_at, language:language(review),
      author:text(review.user?.displayName || review.user?.display_name),
      verified:Boolean(review.verifiedBuyer ?? review.verified_buyer), shop:Boolean(review.isShop),
      images:(review.imagesData || review.images_data || []).filter(i=>!(Number(i.imageWidth ?? i.image_width)<=2 && Number(i.imageHeight ?? i.image_height)<=2)).map(i=>({thumb:i.thumbUrl || i.thumb_url,src:i.originalUrl || i.original_url})),
      videos:(review.videosData || review.videos_data || []),
      comment:review.comment, product:linked,
      votes:Number(review.votesUp ?? review.votes_up ?? 0),
      incentivized:Boolean(review.isIncentivized ?? review.is_incentivized),
      syndication:review.syndicationData || review.syndication_data
    };
  }
  function filter(reviews, {locale,score='',query='',media=false,sort='newest'}) {
    const q=query.trim().toLocaleLowerCase(locale);
    const list=reviews.filter(r=>r.language===locale && (!score || r.score===Number(score)) && (!media || r.images.length || r.videos.length) && (!q || `${r.title} ${r.content}`.toLocaleLowerCase(locale).includes(q)));
    return list.sort((a,b)=> (sort==='highest' ? b.score-a.score : sort==='lowest' ? a.score-b.score : sort==='helpful' ? b.votes-a.votes : 0) || Date.parse(b.date)-Date.parse(a.date) || b.id.localeCompare(a.id));
  }
  function stats(reviews) {
    const distribution={1:0,2:0,3:0,4:0,5:0};let sum=0;
    reviews.forEach(r=>{distribution[r.score]++;sum+=r.score;});
    return {count:reviews.length,average:reviews.length ? sum/reviews.length : 0,distribution};
  }
  // Shortest-column placement preserves every existing position when a batch is appended.
  function masonry(heights, columns, gap) {
    const bottoms=Array(Math.max(1,columns)).fill(0);
    const positions=heights.map(height=>{
      const column=bottoms.indexOf(Math.min(...bottoms)),top=bottoms[column];
      bottoms[column]=top+height+gap;
      return {column,top};
    });
    return {positions,height:heights.length?Math.max(...bottoms)-gap:0};
  }
  function canDisplay(reviews, locale, minimum=0) { return reviews.filter(r=>r.language===locale).length>=minimum; }
  window.MamaWillowReviewData = Object.freeze({text,language,normalize,filter,stats,masonry,canDisplay});
})();
